import { Box, Text, IcoMoon } from '@usap/uicomponents'
import styled from 'styled-components'

export const ImageUploadBox = styled(Box)`
    display: none;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
    margin-top: 16px;
    flex-direction: row;
  `
export const ToggleBox = styled(Box)`
    display: inline;
    text-align: center;
    margin-top: 16px;
    flex-direction: column;
    width: 100%;
    cursor: pointer;
    color: #05629B;
  `
export const ToggleText = styled(Text)`
    color: #05629B;
    line-height: 28px;
    display: inline-flex;
    text-align: right;
    font-size: 14px;
  `
export const ImageUploadIcon = styled(IcoMoon)`
    color: #05629B;
    fill: #05629B;
    width: 24px;
    height: 28px;
  `
